import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRandom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRandom"><Path d="M12 17.5V21.5M12 2.5V6.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.8893 15.8891L18.7177 18.7175M5.28271 5.28249L12 12L5.28294 18.7173M18.718 5.28223L15.8895 8.11065" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 11.9995L21.5 11.9995M2.5 11.9995H11.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconRandom;
